import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

export type FavoriteParameter = {
  id: string;
  contentType: string;
};

export class AddFavoriteChannel extends MicroviewCommunicationChannel<FavoriteParameter, Promise<void>> {
  public name: string = 'AddFavoriteChannelChannel';
  public namespace: string = 'SearchMicroview.Favorite';
}

export class RemoveFavoriteChannel extends MicroviewCommunicationChannel<FavoriteParameter, Promise<void>> {
  public name: string = 'RemoveFavoriteChannelChannel';
  public namespace: string = 'SearchMicroview.Favorite';
}
